import {configureStore} from '@reduxjs/toolkit';
import authSlice, {AuthState} from './features/auth/authSlice';
import settingsSlice, {SettingsState} from "./features/settings/settingsSlice";
import appUserSlice, {AppUserState} from "./features/app-user/appUserSlice";
import legalCaseSlice, {LegalCaseState} from "./features/legal-case/legalCaseSlice";
import taskSlice, {TaskState} from "./features/task/taskSlice";
import noticeSlice, {NoticeState} from "./features/notices/legalNotice";
import appDataSlice, {AppDataState} from "./features/appData/appDataSlice";
import contractSlice, {ContractState} from "./features/contracts/contractSlice";
import notificationSlice, {NotificationState} from "./features/notifications/notification";
import searchSlice, {SearchState} from "./features/search/searchSlice";

export interface AppState {
    auth: AuthState;
    settings: SettingsState;
    appUser: AppUserState;
    legalCase: LegalCaseState;
    task: TaskState;
    notices: NoticeState;
    appData: AppDataState;
    contract: ContractState;
    notification: NotificationState;
    search: SearchState;
}

const appReducer = {
    auth: authSlice,
    settings: settingsSlice,
    appUser: appUserSlice,
    legalCase: legalCaseSlice,
    task: taskSlice,
    notices: noticeSlice,
    appData: appDataSlice,
    contract: contractSlice,
    notification: notificationSlice,
    search: searchSlice
};

const store = configureStore({
    reducer: appReducer
});

export default store;
